// extracted by mini-css-extract-plugin
export default {"link":"Message__link--Fyeke"};